import { defineStore } from 'pinia';

export const useRefStore = defineStore('ref', {
    state: () => ({
        topPointsRef: null,
        topCoinRef: null,
        flyingIconsRef: null,
        taskListRef: null,
        tradingViewRef: null,
    }),
    actions: {
        setTopPointsRef(ref) {
            this.topPointsRef = ref;
        },
        setTopCoinRef(ref) {
            this.topCoinRef = ref;
        },
        setFlyingIconsRef(ref) {
            this.flyingIconsRef = ref;
        },
        setTaskListRef(ref) {
            this.taskListRef = ref;
        },
        setTradingViewRef(ref) {
            this.tradingViewRef = ref;
        },
    }
});